__turbopack_context__.v({
  "banner": "styles-module-scss-module__kl8vCG__banner",
  "banner__image": "styles-module-scss-module__kl8vCG__banner__image",
  "banner__min": "styles-module-scss-module__kl8vCG__banner__min",
  "banner__wide": "styles-module-scss-module__kl8vCG__banner__wide",
  "wrapper": "styles-module-scss-module__kl8vCG__wrapper",
});
